import {
  BaseQueryApi,
  FetchArgs,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react';
import { RootState } from '../../state/store';
import queryString from 'query-string';
import { notifyDismissible } from '../../components/showNotification';
import { CustomFormattedMessage } from '../../i18n/i18n';

const SILENTLY_HANDLED_ERRORS = [
  'CARD_ALREADY_IN_USE_SAME_ACCOUNT',
  'CARD_ALREADY_IN_USE_OTHER_ACCOUNT',
];

const SILENTLY_HANDLED_STATUS: Record<string, number[]> = {
  '/v1/pace/cards': [401],
};

const handleError = (error: any, args?: string | FetchArgs) => {
  const url = (typeof args != 'string' && args?.url) || '';

  if (
    !SILENTLY_HANDLED_ERRORS.includes(error?.data?.errorCode) &&
    !(SILENTLY_HANDLED_STATUS[url] || []).includes(error.status)
  ) {
    notifyDismissible(
      'error',
      <CustomFormattedMessage
        id={'base.body.notificationBanner.restFailureMessage'}
      />,
      'base.body.notificationBanner.restFailureTitle',
    );
  }
  return { error };
};

export const restBaseQuery: any = (url: string) => {
  try {
    const baseQuery = fetchBaseQuery({
      baseUrl: url,
      paramsSerializer: (params: Record<string, unknown>) =>
        queryString.stringify(params, { arrayFormat: 'none' }),
      prepareHeaders: (headers, { getState }) => {
        const token = (getState() as RootState).login.user.accessToken;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      },
    });

    return async (
      args: string | FetchArgs,
      api: BaseQueryApi,
      extraOptions: {},
    ) => {
      const { error, data } = await baseQuery(args, api, extraOptions);
      if (error) {
        return handleError(error, args);
      }
      return { data };
    };
  } catch (error: any) {
    return handleError(error);
  }
};
